import { render } from "./BadgeTemplateManageView.vue?vue&type=template&id=0145737a&scoped=true"
import script from "./BadgeTemplateManageView.vue?vue&type=script&lang=js"
export * from "./BadgeTemplateManageView.vue?vue&type=script&lang=js"

import "./BadgeTemplateManageView.vue?vue&type=style&index=0&id=0145737a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0145737a"]])

export default __exports__